import { render, staticRenderFns } from "./group-bar.vue?vue&type=template&id=229d9dd6&scoped=true"
import script from "./group-bar.vue?vue&type=script&lang=js"
export * from "./group-bar.vue?vue&type=script&lang=js"
import style0 from "./group-bar.vue?vue&type=style&index=0&id=229d9dd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d9dd6",
  null
  
)

export default component.exports